import { render, staticRenderFns } from "./AttendeesCard.vue?vue&type=template&id=4e8ce335&scoped=true"
import script from "./AttendeesCard.vue?vue&type=script&lang=js"
export * from "./AttendeesCard.vue?vue&type=script&lang=js"
import style0 from "./AttendeesCard.vue?vue&type=style&index=0&id=4e8ce335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8ce335",
  null
  
)

export default component.exports